import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@optiflow/types';
import { RequirePermission } from '@/routes/RequirePermission';
import { ExpenseCategoriesPage } from './pages/ExpenseCategoriesPage';
import { ExpenseDetailPage } from './pages/ExpenseDetailPage';
import { RecordExpensePage } from './pages/RecordExpensePage';

/** Wraps a route in its guard, so the permission is refused before anything is requested. */
function guarded(permission: string, route: RouteObject): RouteObject {
  return { element: <RequirePermission permission={permission} />, children: [route] };
}

/**
 * The expense routes beneath the list, which the navigation itself provides.
 *
 * Three capabilities and no others: reading is `expenses.view`, recording and voiding are
 * `expenses.manage`, and the category master is `expenses.categories.manage`. The deprecated
 * `expenses.create` and `expenses.approve` authorise nothing here.
 *
 * `new` and `categories` are declared before the dynamic segment so neither is read as an id.
 */
export const expenseRoutes: RouteObject[] = [
  guarded(PERMISSIONS.EXPENSES_MANAGE, {
    path: '/finance/expenses/new',
    element: <RecordExpensePage />,
  }),
  guarded(PERMISSIONS.EXPENSES_CATEGORIES_MANAGE, {
    path: '/finance/expenses/categories',
    element: <ExpenseCategoriesPage />,
  }),
  guarded(PERMISSIONS.EXPENSES_VIEW, {
    path: '/finance/expenses/:expenseId',
    element: <ExpenseDetailPage />,
  }),
];
